import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { IGeoValue, IJsonQueryGeo } from '../../types/filters/user_geo';
import { useApplicationContext } from '../../utils/applicationContext';
import { TThunkDispatch } from '../../types/redux';
import {
  TSuggestResult,
  IYandexSuggestOptions,
  suggest,
  selectGeo,
  clearGeo,
  geocode,
  setRegion,
  setVillage,
  setBSCenters,
  setBuilder,
  setCoworkingIds,
  changeGeoSearch,
  validateGeo,
} from '../../actions/filters';
import { FilterGeo } from '../../components/FilterGeo';
import { getGeoBbox } from '../../actions/filters/geo/getGeoBoundedBy';
import { selectGeoSearch } from '../../selectors/filters/geoSearch';
import { selectIsGeoLoading } from '../../selectors/filters';
import { selectFiltersClientErrors } from '../../selectors/filters/clientErrors';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { selectUserGeo } from '../../selectors/selectUserGeo';
import { selectSuggestions } from '../../selectors/filters/selectSuggestions';

export const FilterGeoContainer = () => {
  const { telemetry } = useApplicationContext();

  const { geo, region } = useSelector(selectJsonQuery);
  const suggestions = useSelector(selectSuggestions);
  const userGeo = useSelector(selectUserGeo);
  const search = useSelector(selectGeoSearch);
  const isLoading = useSelector(selectIsGeoLoading);
  const clientErrors = useSelector(selectFiltersClientErrors);

  const dispatch = useDispatch<TThunkDispatch>();

  return (
    <FilterGeo
      geo={geo as IJsonQueryGeo}
      suggestions={suggestions}
      regionOrMaintownId={region?.value[0] || userGeo}
      search={search}
      isLoading={isLoading}
      geoError={clientErrors.geo}
      telemetry={telemetry}
      getGeoBbox={(regionOrMaintownId: number) => dispatch(getGeoBbox(regionOrMaintownId))}
      getSuggestions={(query: string, options?: IYandexSuggestOptions): Promise<TSuggestResult> =>
        dispatch(suggest({ query, options }))
      }
      setRegion={(region: number[]) => dispatch(setRegion(region))}
      setVillage={(villageId: number | undefined) => dispatch(setVillage(villageId))}
      setBSCenters={(bsCenterIds: number[]) => dispatch(setBSCenters(bsCenterIds))}
      selectGeo={(geoValue: IGeoValue) => dispatch(selectGeo(geoValue))}
      geocode={(query: string): Promise<IGeoValue> => dispatch(geocode({ query }))}
      clearGeo={() => dispatch(clearGeo())}
      setBuilder={(builderId: number) => dispatch(setBuilder(builderId))}
      setCoworkingIds={(coworkingIds: number[]) => dispatch(setCoworkingIds(coworkingIds))}
      changeSearch={(geoSearch: string) => dispatch(changeGeoSearch(geoSearch))}
      clearGeoError={() => dispatch(validateGeo(null))}
    />
  );
};
